import {Component, Input} from '@angular/core';
import {AppointmentErrorFields} from '@drl/shared/models/csv-upload-report.model';

@Component({
  selector: 'app-appointments-report',
  templateUrl: './appointments-report.component.html',
  styleUrls: [],
})
export class AppointmentsReportComponent {
  @Input() appointmentsErrors: AppointmentErrorFields[];
}
